import { useState, useCallback } from "react";

const MiniDrone = ({ size = 40 }) => (
  <svg width={size} height={size / 2} viewBox="0 0 120 60" fill="none" className="drone-glow shrink-0">
    <g className="drone-prop" style={{ transformOrigin: "18px 14px" }}>
      <ellipse cx="18" cy="14" rx="16" ry="3.5" fill="#2ec4b6" opacity="0.85" />
    </g>
    <g className="drone-prop drone-prop-alt" style={{ transformOrigin: "102px 14px" }}>
      <ellipse cx="102" cy="14" rx="16" ry="3.5" fill="#2ec4b6" opacity="0.85" />
    </g>
    <rect x="14" y="14" width="8" height="12" rx="3" fill="#a1a1aa" />
    <rect x="98" y="14" width="8" height="12" rx="3" fill="#a1a1aa" />
    <path d="M22 24 L48 32 M98 24 L72 32" stroke="#a1a1aa" strokeWidth="5" strokeLinecap="round" />
    <rect x="42" y="28" width="36" height="16" rx="8" fill="#e4e4e7" />
  </svg>
);

export const DroneDropChip = ({ onDropAt }) => {
  const [drag, setDrag] = useState(null);

  const startDrag = useCallback((e) => {
    e.preventDefault();
    setDrag({ x: e.clientX, y: e.clientY });
    const move = (ev) => setDrag({ x: ev.clientX, y: ev.clientY });
    const up = (ev) => {
      window.removeEventListener("pointermove", move);
      window.removeEventListener("pointerup", up);
      setDrag(null);
      const el = document.elementFromPoint(ev.clientX, ev.clientY);
      if (el && el.closest('[data-testid="map-container"]')) onDropAt(ev.clientX, ev.clientY);
    };
    window.addEventListener("pointermove", move);
    window.addEventListener("pointerup", up);
  }, [onDropAt]);

  return (
    <>
      <div
        data-testid="drone-drop-chip"
        onPointerDown={startDrag}
        title="Drag me anywhere on the map"
        className="absolute top-4 left-1/2 -translate-x-1/2 z-[510] flex items-center gap-3 bg-black/70 backdrop-blur-xl border border-[#2ec4b6]/50 rounded-full pl-3 pr-5 py-2.5 shadow-2xl cursor-grab active:cursor-grabbing hover:border-[#2ec4b6] transition-colors select-none touch-none"
      >
        <MiniDrone />
        <div className="leading-tight">
          <p className="text-sm font-heading font-semibold text-white">Drop the drone</p>
          <p className="text-[11px] text-zinc-300">Drag onto the map to fly in &amp; check the spot</p>
        </div>
      </div>
      {drag && (
        <div
          data-testid="drone-drop-ghost"
          className="fixed z-[600] pointer-events-none -translate-x-1/2 -translate-y-1/2"
          style={{ left: drag.x, top: drag.y }}
        >
          <MiniDrone size={56} />
        </div>
      )}
    </>
  );
};
